import React, { useState, useEffect } from 'react'
import { Popup, Button } from 'semantic-ui-react'


const InListPopup = props => {

	const { icon, Comp, params } = props
	const [display, setDisplay] = useState(false)

	// useEffect(() => {
	// 	if (display)
	// 		return firebase_database.watch_record(path, d => setData(d))
	// }, [display])

	return <Popup
		trigger={<Button icon={icon || 'fire'} onClick={_ => setDisplay(true)} />}
		position='left center'
		on='click'
		style={{ height: '80%', width: '80%', minWidth: 700, overflow: 'scroll', maxHeight: '90vh' }}
	>
		{display &&
			<Comp
				{...params}
			/>}
	</Popup>
}

export default InListPopup
